import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'
import {getNotificationSoundUrl} from '@toolify/client/src/stores/NotificationStore/functions/getNotificationSoundUrl'
import {
  GetNewMessageNotificationTitleByConversationTypeMap,
} from '@toolify/client/src/stores/NotificationStore/maps/GetNewMessageNotificationTitleByConversationTypeMap'
import {DefaultNotificationStrategy} from './DefaultNotificationStrategy'

export class NewMessageNotificationStrategy extends DefaultNotificationStrategy<NotificationType.NewMessage> implements INotificationTypeStrategy {
  getBrowserNotification(notification: INotificationResponseInstance<NotificationType.NewMessage>, authorNick: string): IBrowserNotification {
    const title = GetNewMessageNotificationTitleByConversationTypeMap.get(notification.payload.conversationType)(authorNick, notification.payload)
    const body = notification.payload.truncatedContent
    return {
      sound: getNotificationSoundUrl('new-message.wav'),
      title,
      body,
    }
  }
}
